// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1gAK1","info":"Note_info__YYSA5","note":"Note_note__ahyQ8","actions":"Note_actions__3FcO2"};